import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild , Renderer2, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { HomepageVideoService } from 'src/app/services/homepage-video.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-homepage-video',
  templateUrl: './homepage-video.component.html',
  styleUrls: ['./homepage-video.component.scss'],
  providers: [ConfirmationService, TitleCasePipe, MessageService]
})

export class HomepageVideoComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  searchBy: any[] = [];
  searchby: any;
  startDate: Date;
  endDate: Date;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  homePageVideoData: any;
  totalHomePageVideoDataCount: number = 0;
  paginationOption: any;
  calvalue: Date;
  ucalvalue: Date;
  statuses: any[];
  errorMessage: any;
  showThumbNailImage: boolean = false;
  loading: boolean;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  thumbnailImageArray: any[] = [];

  constructor(  private renderer: Renderer2,private router: Router, private homePageVideoService: HomepageVideoService, private messageService: MessageService, private confirmationService: ConfirmationService,) { }

  ngOnInit(): void {
        this.renderer.addClass(document.body, "homePageVideos-page");
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
  }

  addNewHomePageVideo() {
    this.router.navigate(['/manage/homepagevideo/add']);
  }

  loadHomePageVideosList(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (event.filters != undefined && event.filters["title"] != undefined) {
      params += "&filterByTitle=" + event.filters["title"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["createdBy"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdBy"].value;
    }
    if (event.filters != undefined && event.filters["updatedBy"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedBy"].value;
    }

    // at the time of download hide pagination option
    // if (this.downloadFlg == false) {
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    // } else {
    //   if (params != undefined && params != "") {
    //     query += params;
    //   }
    // }

      if (event.sortField != undefined && event.sortOrder != undefined) {
        let orderBy = "";
        if (event.sortOrder == 1) {
          orderBy = "DESC";
        } else {
          orderBy = "ASC";
        }
        query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
      }

    this.homePageVideoService.getAllHomePageVideosData(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.homePageVideoData = data.data.items;
      this.thumbnailImageArray = this.homePageVideoData[0]?.thumbNailImage;
      this.totalHomePageVideoDataCount = data.data.totalCount;
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'title', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'createdBy', 'contains');
    this.dt.filter('', 'updatedBy', 'contains');
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = '';
    }
  }

  onShowThumbNailImage(thumbNailImage) {
    this.showThumbNailImage = true;
    this.thumbnailImageArray = thumbNailImage;
  }

  changeStatus(homePageVideoData) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(homePageVideoData.title)) + '?',
         message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,
 
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      accept: () => {
        var updatedata = {};
        updatedata['status'] = homePageVideoData.status;
        this.homePageVideoService.updateHomePageVideo(homePageVideoData.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Home Page Video Status Updated', life: 3000 });
            setTimeout(()=>{
              this.loadHomePageVideosList(this.lastTableLazyLoadEvent);
            },1000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        homePageVideoData.status = !homePageVideoData.status;
        this.loadHomePageVideosList(this.lastTableLazyLoadEvent);
      }
    });
  }
  onDelete(homePageVideoData) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to delete record ' + '?',
      message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this record ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 
      accept: () => {
        var updatedata = '{"disable":true}';
        // console.log(cmsmodule._id);
        this.homePageVideoService.updateHomePageVideo(homePageVideoData.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Home Page Video Deleted', life: 3000 });
            this.loadHomePageVideosList(this.lastTableLazyLoadEvent);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadHomePageVideosList(this.lastTableLazyLoadEvent);
      }
    });
  }
  onEditHomePageVideoData(homePageVideoData) {
    this.router.navigate(['/manage/homepagevideo/edit/' + homePageVideoData.id]);
  }
 addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }

     ngOnDestroy() {
    this.renderer.removeClass(document.body, 'homePageVideos-page');
    this.destroy$.next();
    this.destroy$.complete();
  }
}
